import { isProductionEnv, isSSR } from "./utils";

export const POLL_PRICES_API_INTERVAL = 30000; // ms
export const GREENHOUSE_API_ENDPOINT =
  "https://boards-api.greenhouse.io/v1/boards/gemini/jobs";
export const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;
export const SENTRY_DEBUG = Boolean(process.env.SENTRY_DEBUG);

// Set Production and Staging Links for Axios
// Axios Requires a Base URL for internal API requests
const DEPLOY_URL = process.env.NEXT_PUBLIC_URL;
const DEV_URL = process.env.DEV_URL || "http://gemini.local";
export const BASE_URL =
  process.env.NODE_ENV !== "development" ? DEPLOY_URL : DEV_URL;
const PRICES_API_PATH = "/api/prices";
export const PRICES_API_URL = !isSSR()
  ? PRICES_API_PATH
  : `${BASE_URL}${PRICES_API_PATH}`;
const ALL_PRICES_API_PATH = "/api/all-prices";
export const ALL_PRICES_API_URL = !isSSR()
  ? ALL_PRICES_API_PATH
  : `${BASE_URL}${ALL_PRICES_API_PATH}`;

// PROD keys injected from Netlify.com UI due to senstive info
export const SENTRY_SECRET = isProductionEnv
  ? process.env.NEXT_PUBLIC_SENTRY_SECRET_PROD
  : process.env.NEXT_PUBLIC_SENTRY_SECRET_STAGING;

export const EXCHANGE_BASE_URL = isProductionEnv
  ? "https://exchange.gemini.com"
  : "https://exchange.sandbox.gemini.com";
export const CREDIT_CARD_BASE_URL = "https://creditcard.exchange.gemini.com";
// export const EXCHANGE_BASE_URL = "https://exchange.qa100.aurora7.net"; // Uncomment to use QA100
export const API_BASE_URL = "https://api.gemini.com";
// export const API_BASE_URL = "https://api.qa100.aurora7.net"; // Uncomment to use QA100

// Recaptcha site key
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
export const AFFINITY_RECAPTCHA_KEY =
  process.env.NEXT_PUBLIC_AFFINITY_RECAPTCHA_KEY;
export const AFFINITY_RECAPTCHA_KEY_NAME =
  process.env.NEXT_PUBLIC_AFFINITY_RECAPTCHA_KEY_NAME;

// Algolia
export const ALGOLIA_ID = process.env.NEXT_PUBLIC_ALGOLIA_ID;
export const ALGOLIA_API_KEY = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY;
export const ALGOLIA_BLOG_INDEX_NAME = "prod_blog_articles";
export const ALGOLIA_WHATS_NEW_ANNOUNCEMENTS = "prod_whats_new_announcements";

// DataDog
export const DATADOG_APPLICATION_ID =
  process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN =
  process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
export const DATADOG_SITE = "datadoghq.com";
export const DATADOG_SERVICE =
  process.env.NEXT_PUBLIC_DATADOG_SERVICE || "gemini-public";
export const DATADOG_ENV =
  // Runtime-accessible build environment variables (configured in next.config.ts)
  process.env.RUNTIME_CONTEXT ||
  process.env.NEXT_PUBLIC_DATADOG_ENV ||
  process.env.NODE_ENV ||
  "development";
// Runtime-accessible build environment variables (configured in next.config.ts)
export const APP_VERSION = process.env.RUNTIME_COMMIT_REF || "1.0.0";
export const DATADOG_SESSION_SAMPLE_RATE = isProductionEnv ? 100 : 0;
